//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const StrictWorkflowManualOverrideConfirm: FeatureFlag = {"Id":"StrictWorkflowManualOverrideConfirm","Label":"Use strict confirm for Workflow Manual Override","Impact":"Users have to type 'confirm' instead of just clicking to execute manual override","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
